import React, {Component} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontEvent} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {TeammateModel} from '../../../../../libs/shared/core/src/models/api/teammateModel';
import {buildTeammateDisplayName} from '../../../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemCheckbox} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemCheckbox';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {
  AsyncSearchDropdown,
  AsyncSearchDropdownDataFetcher,
} from '../../../../../libs/shared/ui/src/components/dropdowns/search/asyncSearchDropdown';
import {DropdownItemTeammateAvatar} from '../../../common/dropdowns/dropdownItemTeammateAvatar';
import {workspacesEditorDropdownWidth} from '../editor/context/types';

/*
 * Props.
 */

type ToggleTeammateHandler = (teammate: TeammateModel) => void;

interface WorkspaceTeammatesDropdownProps extends DropdownProps {
  displayedTeammateIds: ReadonlyArray<number>;
  toggleTeammate: ToggleTeammateHandler;
  fetchTeammatesAsync: AsyncSearchDropdownDataFetcher<TeammateModel, any>;
}

/*
 * Component.
 */

export class WorkspaceTeammatesDropdown extends Component<WorkspaceTeammatesDropdownProps, {query: string}> {
  constructor(props: WorkspaceTeammatesDropdownProps) {
    super(props);

    this.state = {query: ''};
    this.renderRow = this.renderRow.bind(this);
    this.isTeammateChecked = this.isTeammateChecked.bind(this);
  }

  /*
   * Event handlers.
   */

  render() {
    return (
      <AsyncSearchDropdown
        {...this.props}
        interactionId="workspace-teammates-dropdown"
        headerTitle={<Trans id="workspace-teammates">Teammates</Trans>}
        query={this.state.query}
        onQueryChange={(newQuery) => this.setState({query: newQuery})}
        width={workspacesEditorDropdownWidth}
        onRequestData={this.props.fetchTeammatesAsync}
        renderRow={this.renderRow}
      />
    );
  }

  private isTeammateChecked(teammate: TeammateModel) {
    return this.props.displayedTeammateIds.includes(teammate.id);
  }

  private renderRow(teammate: TeammateModel, index: number) {
    const {toggleTeammate} = this.props;
    const isChecked = this.isTeammateChecked(teammate);
    const onTeammateSelect: (event: FrontEvent) => void = (e) => {
      e.preventDefault(); // Keep the dropdown open
      toggleTeammate(teammate);
    };

    return (
      <DropdownItem
        index={index}
        onSelect={onTeammateSelect}
        renderRightContent={() => <DropdownItemCheckbox isChecked={isChecked} />}
      >
        <DropdownItemTeammateAvatar teammate={teammate} />
        <DropdownItemContent isChecked={isChecked}>{buildTeammateDisplayName(teammate)}</DropdownItemContent>
      </DropdownItem>
    );
  }
}
